import * as React from "react"

interface IconProps {
  color?: string
}

export const YoutubeIcon: React.FunctionComponent<IconProps> = ({ color = "#fff" }) => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.2925 10.8726C32.9254 9.5948 31.8438 8.58845 30.4705 8.24693C27.9813 7.62634 18 7.62634 18 7.62634C18 7.62634 8.01872 7.62634 5.52948 8.24693C4.15619 8.5885 3.0746 9.5948 2.7075 10.8726C2.04053 13.1887 2.04053 18.021 2.04053 18.021C2.04053 18.021 2.04053 22.8533 2.7075 25.1693C3.0746 26.4471 4.15619 27.4116 5.52948 27.7531C8.01872 28.3737 18 28.3737 18 28.3737C18 28.3737 27.9813 28.3737 30.4705 27.7531C31.8438 27.4116 32.9254 26.4471 33.2925 25.1693C33.9595 22.8533 33.9595 18.021 33.9595 18.021C33.9595 18.021 33.9595 13.1887 33.2925 10.8726ZM14.7355 22.4083V13.6336L23.078 18.0211L14.7355 22.4083Z"
      fill={color}
    />
  </svg>
)
